import React, { Component } from "react";
import firebase from "../../firebase";
import EditPage from "./Page_Edit";
// Style mods
import { Route, Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
// Warnings and confirmations
import * as alerts from "./../components/Page-alerts";

const styles = theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto"
  },
  table: {
    minWidth: 700
  },
  button: {
    margin: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  }
});

class Pages extends Component {
  state = {
    pages:
      sessionStorage.allPages !== undefined
        ? JSON.parse(sessionStorage.allPages)
        : [],
    editThisPage:
      sessionStorage.currentEditPage !== undefined
        ? Number(sessionStorage.currentEditPage)
        : null,
    deleteConfirm: false,
    deleteHome: false,
    deleteID: null,
    deleteFail: false
  };

  componentDidMount() {
    let ref = firebase.database().ref("/pages");
    ref.on("value", snap => {
      let val = snap.val();
      if (val[0] === undefined) {
        val.shift();
      }
      this.setState(
        { pages: val },
        () => (sessionStorage.allPages = JSON.stringify(val))
      );
    });
  }

  componentWillUnmount() {
    firebase
      .database()
      .ref()
      .off();
  }

  addPage = () => {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("/pages")
        .on("value", snap => {
          let val = snap.val();
          if (val[0] === undefined) {
            val.shift();
          }
          let newPage = {
            title: "Title Placeholder",
            status: "draft",
            content: "Content Placeholder",
            isHome: "false"
          };
          let updatedPages = [...val, newPage];
          resolve(updatedPages);
        });
    }).then(updatedPages => {
      firebase
        .database()
        .ref("/pages")
        .set(updatedPages);
    });
  };

  editPage = id => {
    this.setState({ editThisPage: id, deleteHome: false }, () => {
      sessionStorage.currentEditPage = this.state.editThisPage;
    });
  };

  deleteCheck = id => {
    this.setState({ deleteHome: false, deleteID: id });
    firebase
      .database()
      .ref(`/pages/${id}`)
      .on("value", snap => {
        let val = snap.val();
        if (!val) return;
        if (val.isHome === "true")
          return this.setState({ deleteHome: true, deleteConfirm: false });
        this.setState({ deleteConfirm: true });
      });
  };

  deletePage = () => {
    let id = this.state.deleteID;
    this.setState({ deleteConfirm: false });
    firebase
      .database()
      .ref(`/pages/${id}`)
      .remove()
      .catch(e => {
        this.setState({ deleteFail: true });
        console.error("Operation Failure: ", e);
      });
  };

  abortDelete = () => this.setState({ deleteConfirm: false });

  render() {
    const { classes } = this.props;
    return (
      <section className="page-component-container">
        <AppBar position="static" color="default" className="pages-title">
          <Toolbar>
            <Typography variant="title" color="inherit">
              All Pages
            </Typography>
          </Toolbar>
        </AppBar>

        <Link to="/admin/pages">
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={this.addPage}
          >
            Add Page
          </Button>
        </Link>

        {this.state.deleteFail ? alerts.deleteFailure : null}

        {this.state.deleteHome ? alerts.deleteHomePg : null}

        {this.state.deleteConfirm ? (
          <p className="alert alert-danger">
            Are you sure you want to remove this page? This action cannot be
            undone.{" "}
            <Button
              color="primary"
              variant="contained"
              onClick={this.deletePage}
            >
              Proceed
            </Button>{" "}
            <Button
              color="secondary"
              variant="contained"
              onClick={this.abortDelete}
            >
              Go Back
            </Button>
          </p>
        ) : null}

        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell>Page ID</TableCell>
                <TableCell>Page Title</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Excerpt</TableCell>
                <TableCell>Update / Delete</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.pages.map((page, id) => (
                <TableRow key={id}>
                  <TableCell>{id}</TableCell>
                  <TableCell>
                    {
                      (page.title =
                        page.title.charAt(0).toUpperCase() +
                        page.title.substring(1))
                    }
                  </TableCell>
                  <TableCell>{page.status}</TableCell>
                  <TableCell>{`${page.content.substring(
                    0,
                    140
                  )}...`}</TableCell>
                  <TableCell>
                    <Link to={`/admin/pages/edit?pageId=${id}`}>
                      <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        onClick={() => this.editPage(id)}
                      >
                        Edit
                      </Button>
                    </Link>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.button}
                      onClick={() => this.deleteCheck(id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>

        <Route
          exact
          path="/admin/pages/edit"
          render={() => (
            <EditPage
              pages={this.state.pages}
              id={this.state.editThisPage}
              key={Math.random()}
            />
          )}
        />
      </section>
    );
  }
}

export default withStyles(styles)(Pages);



// WEBPACK FOOTER //
// ./src/admin/pages/Pages.js